import React from 'react'

const RiskListIcon = () => {
    return (
        <>
            <svg
                width={10}
                height={15}
                viewBox="0 0 98 126"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.17381 3.12177C3.132 4.829 2.94381 7.05714 4.13014 8.95256C23.4441 40.6538 23.1385 81.4693 3.86505 113.053L1.78144 116.468C0.739633 118.175 0.0305408 121.257 2.07049 123.673C4.63133 125.236 7.71309 125.945 10.1294 123.905L95.0907 69.1454C96.4652 68.8127 97.507 67.1055 97.6952 64.8774C97.8834 62.6492 96.6971 60.7538 94.9898 59.712L13.2745 1.64639L12.4209 1.12549C9.86007 -0.437218 6.25742 -0.292695 4.69471 2.26815L4.17381 3.12177Z"
                    fill="#CF3A45"
                />
            </svg>
        </>
    )
}

export default RiskListIcon